import {
    type EvergladesProductsApiSuccess,
    type RankedIntentResult,
    isContextIntent,
    isRankedIntent,
} from '@shared/types/types.ts';
import type { ProductItem } from '@tilelist/domain/composition/TileListitem.ts';

export type TileListLiteComposite = {
    rule: string;
    tileListItems: ProductItem[];
    count: number;
    assortment?: string;
};

export function composeTileListLite(response: EvergladesProductsApiSuccess): TileListLiteComposite {
    const rankedIntent = response.intents.find(isRankedIntent);
    const contextIntent = response.intents.find(isContextIntent);
    return {
        rule: response.rule ?? '',
        tileListItems: rankedIntent ? fromRankedIntentToProductItem(rankedIntent) : [],
        count: rankedIntent?.count ?? 0,
        assortment: contextIntent?.topNImplicit?.assortmentNavigation?.[0],
    };
}

function fromRankedIntentToProductItem(intent: RankedIntentResult): ProductItem[] {
    const offset = intent.meta?.offset ?? 0;
    return intent.products.map((product, i): ProductItem => {
        return {
            product,
            variations: [],
            type: 'AS',
            localListPosition: i + 1,
            actualListPosition: i + offset + 1,
            originPosition: i + offset, /*         */
        };
    });
}
